import { drawing } from '@progress/kendo-drawing';
const { elementOffset, limitValue, } = drawing.util;
export { elementOffset, limitValue };
